import { KCommandGroup } from '../cmdkTypes'
import { KGroupProcessor } from '../useCommandStore'
/**
 * Add a reference to the parent group to each command.
 *
 * A little icky, but allows access to shared defaults, like path.
 */
export const addGroup: KGroupProcessor = (group: KCommandGroup) => {
  const { commands } = group
  return { ...group, commands: commands.map((cmd) => ({ ...cmd, group })) }
}
